import { Action } from '@ngrx/store';
import { SearchServiceModel } from './model';

export enum ActionTypes {
  FAILURE = '[SearchService] Failure',

  SEARCH_REQUEST = '[SearchService] Search Request',
  SEARCH_SUCCESS = '[SearchService] Search Success',

  SET_SELECTED_REQUEST = '[SearchService] SetSelected Request',
  SET_SELECTED_SUCCESS = '[SearchService] SetSelected Success',
}

export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class SearchRequestAction implements Action {
  readonly type = ActionTypes.SEARCH_REQUEST;
  constructor(public searchString: string) {}
}

export class SearchSuccessAction implements Action {
  readonly type = ActionTypes.SEARCH_SUCCESS;
  constructor(public items: SearchServiceModel[]) {}
}

export class SetSelectedRequestAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_REQUEST;

  constructor(public model: SearchServiceModel) {}
}

export class SetSelectedSuccessAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_SUCCESS;

  constructor(public model: SearchServiceModel) {}
}

export type Actions = FailureAction | SearchRequestAction | SearchSuccessAction | SetSelectedRequestAction | SetSelectedSuccessAction;
